import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import {
  Feature,
  FeatureActionFields,
  FeatureCommands,
  FeaturePropertyKey,
  VitotrolRemoteControllerCommands,
  VitotrolRemoteControllerProperties,
} from '@vi-iot/client';

import { InstallationFeaturesStore } from '@store';

import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { GTMService } from '@services';
import { CloseEventDialog } from '../../../single-room-control/src-overlay/commissioning/commissioning-delete-device-confirm-modal/commissioning-delete-device-confirm-modal.component';
import { SelectVitotrolDeviceModalComponent } from '../select-vitotrol-device-modal/select-vitotrol-device-modal.component';
import { UnassignVitotrolRemoteControllerConfirmModalComponent } from '../unassign-vitotrol-remote-controller-confirm-modal/unassign-vitotrol-remote-controller-confirm-modal.component';

@Component({
  selector: 'app-vitotrol-remote-controller',
  templateUrl: './vitotrol-remote-controller.component.html',
  styleUrls: ['./vitotrol-remote-controller.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VitotrolRemoteControllerComponent implements OnInit {
  @Input() featureName: string;

  featureRemoteController$: Observable<
    Feature<VitotrolRemoteControllerProperties, VitotrolRemoteControllerCommands>
  >;
  constructor(
    public installationFeaturesStore: InstallationFeaturesStore,
    private gtmService: GTMService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.featureRemoteController$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      this.featureName
    );
  }

  openAssignRemoteControllerDialog(): void {
    const selectVitotrolRoomModal: MatDialogRef<
      SelectVitotrolDeviceModalComponent,
      { vitotrolId: string; confirmed: boolean }
    > = this.dialog?.open(SelectVitotrolDeviceModalComponent, {
      width: '715px',
      panelClass: 'commissioning-manage-room-dialog',
      disableClose: true,
      autoFocus: false,
      data: {
        currentFeatureName: this.featureName,
      },
    });

    selectVitotrolRoomModal.afterClosed().subscribe((data) => {
      if (data.confirmed) {
        this.installationFeaturesStore.updateFeature(
          this.featureName,
          data.vitotrolId,
          FeaturePropertyKey.deviceId,
          FeatureActionFields.deviceId,
          FeatureCommands.setZigbeeController
        );
        this.gtmService.track(
          'onConfirm',
          'Assign remote controller from ventilation confirmation',
          'ventilation'
        );
      } else {
        this.gtmService.track(
          'onCancel',
          'Assign remote controller from ventilation confirmation',
          'ventilation'
        );
      }
    });
  }

  unassignRemoteControllerDevice(): void {
    const dialogRef = this.dialog?.open(UnassignVitotrolRemoteControllerConfirmModalComponent, {
      width: '715px',
      panelClass: 'commissioning-delete-device-confirm-dialog',
    });

    dialogRef.afterClosed().subscribe((event: CloseEventDialog) => {
      if (event.confirmed) {
        this.installationFeaturesStore.updateFeature(
          this.featureName,
          null,
          null,
          null,
          FeatureCommands.removeZigbeeController
        );
        this.gtmService.track(
          'onConfirm',
          'Unassign remote controller from ventilation confirmation',
          'ventilation'
        );
      } else {
        this.gtmService.track(
          'onCancel',
          'Unassign remote controller from ventilation confirmation',
          'ventilation'
        );
      }
    });
  }
}
